import Button from "@mostrans/web-components/components/base/Button";
import { Paper } from "@mui/material";
import React from "react";

export default function ButtonCarousel({
  index,
  detailArray,
  isActive,
  onClick,
}) {
  return (
    <>
      <Paper
        key={index}
        className={`${isActive === index ? "active-btn" : ""
          } btn-carousel d-flex justify-content-center align-items-center p-1`}
      >
        <Button
          disableRipple
          disableElevation
          onClick={onClick}
          sx={{
            "&.MuiButtonBase-root:hover": {
              bgcolor: "transparent",
            },
          }}
        >
          <span style={{ fontSize: "32px" }}>
            {detailArray.title.charAt(0)}
          </span>
        </Button>
      </Paper>
    </>
  );
}
